/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {
    
    export interface ModelTargetGridOptions {
        modelCode: string;
        modelName: string;
    }

    @Serenity.Decorators.registerClass()
    export class ModelTargetGrid extends SiteEntityGrid<ModelTargetRow, ModelTargetGridOptions> {
        protected getColumnsKey() { return 'Data.ModelTarget'; }
        protected getDialogType() { return ModelTargetDialog; }
        protected getIdProperty() { return ModelTargetRow.Fields.TargetCode; }
        protected getLocalTextPrefix() { return ModelTargetRow.localTextPrefix; }
        protected getService() { return ModelTargetService.baseUrl; }

        private model: Serenity.LookupEditor;
        private rowSelection: Serenity.GridRowSelectionMixin;
        private expandTo: ExpandToLevelEditor;
        private focusToKey: string;
        private focusToKeys: Q.Dictionary<boolean>;

        constructor(container: JQuery, options: ModelTargetGridOptions) {
            super(container, options);

            this.model = Serenity.Widget.create({
                type: FormatLookupEditor,
                options: {
                    lookupKey: ModelRow.lookupKey,
                    inplaceAdd: true,
                    inplaceAddPermission: "DataAdmin:ModelType"
                },
                init: ed => {
                    ed.element.nextAll('.inplace-button').css('margin-right', '6px')
                        .css('position', 'relative').css('top', '2px')
                    var first = this.options.modelCode ? ModelRow.getLookup().itemById[this.options.modelCode] :
                        ModelRow.getLookup().items[0];
                    if (first) {
                        ed.value = first.ModelCode;
                        if (this.expandTo)
                            this.expandTo.modelCode = first.ModelCode;
                    }
                },
                element: el => el.attr('placeholder', '-- Model --')
                    .css('float', 'left')
                    .css('margin-right', 0)
                    .css('width', '400px')
                    .insertAfter(this.toolbar.element.find('.s-QuickSearchBar'))
            });

            this.model.changeSelect2(e => {
                this.refresh();
                this.expandTo.modelCode = this.model.value;
            });

            this.expandTo = Serenity.Widget.create({
                type: ExpandToLevelEditor,
                element: el => el.css('float', 'left')
                    .css('width', '150px')
                    .css('margin-right', "0")
                    .insertAfter(this.model.element.next(".inplace-add").add(this.model.element).eq(0))
            });

            this.expandTo.changeSelect2(e => {
                var level = Q.toId(this.expandTo.value);
                if (level != null)
                    this.expandToLevel(level);
            });

            this.expandTo.modelCode = this.model.value;

            new Serenity.TreeGridMixin({
                grid: this,
                getParentId: x => this.getParentId(x),
                initialCollapse: () => {
                    var expandTo = Q.toId(this.expandTo.value);
                    if (expandTo == null || expandTo == -1)
                        return false;

                    if (expandTo == 0)
                        return true;

                    window.setTimeout(() => this.expandToLevel(expandTo));
                    return true;
                },
                toggleField: "TargetCode"
            });

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);

            this.slickGrid.setSelectionModel(new Slick.RowSelectionModel());
            Serenity.GridUtils.makeOrderable(this.slickGrid, (items: number[], location: number) => {
                if (!items || !items.length)
                    return;

                this.moveItem(items[0], location);
            });

            if (this.options.modelCode) {
                this.model.element.prev('.select2-container').hide();
                this.model.element.next('.inplace-button.inplace-add').hide();
                this.setTitle(this.getTitle() + ": " + this.options.modelCode + " - " + (this.options.modelName || ""));
            }
        }

		private _byParentId: Q.Grouping<ModelTargetRow>;

        private get byParentId() {
            if (this._byParentId)
                return this._byParentId;

            this._byParentId = Q.toGrouping(this.view.getItems(), x => this.getParentId(x));
            return this._byParentId;
        }

		private getParents(item: ModelTargetRow, targetClass: boolean = false): ModelTargetRow[] {
			let result: ModelTargetRow[] = [];
			while (true) {
				var parentId = this.getParentId(item);
				if (parentId == null || (!targetClass && parentId == '-1'))
					return result;
				item = this.view.getItemById(parentId);
				if (item == null)
					return result;
				result.push(item);
			}
		}

		private getDescendants(item: ModelTargetRow): ModelTargetRow[] {
			let result: ModelTargetRow[] = [];
            let byParentId = this.byParentId;
            let stack = [item];
            while (stack.length > 0) {
                let i = stack.pop();
                let children = byParentId[i.TargetCode];
                if (!children)
                    continue;

                for (let child of children) {
                    result.push(child);
                    stack.push(child);
                }
            }

            return result;
		}

        protected expandToLevel(level: number) {
            var items = this.view.getItems();
            for (var item of items) {
                Serenity.SlickTreeHelper.setCollapsedFlag(item,
                    level == 0 || (level > 0 && item.Level >= level));
            }
            this.view.setItems(items, true);
        }

        getParentId(x: ModelTargetRow) {
            if (x.TargetCode == "-1")
                return null;

            if (x.Level <= 1)
                return "-1";

            var s = "";
            for (var i = 1; i < x.Level; i++) {
                if (i > 1)
                    s += "/";
                s += x["Code" + i];
            }

            return s;
        }

        gridPersistanceFlags() {
            var flags = super.gridPersistanceFlags();
            flags.sortColumns = false;
            return flags;
        }

        getButtons() {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            Q.first(buttons, x => x.cssClass === "export-xlsx-button").onClick = () => {
                if (!this.model.value)
                    return;

                Q.postToService({
                    service: "Data/ModelTarget/ExportExcel",
                    request: <ModelTargetExportRequest>{
                        ModelCode: this.model.value
                    },
                    target: "_blank"
                });
            };

            return buttons;
        }

        getGridCanLoad() {
            return super.getGridCanLoad() && !Q.isEmptyOrNull(this.model.value);
        }

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params as Serenity.ListRequest;
            request.EqualityFilter = request.EqualityFilter || {};
            request.EqualityFilter[ModelTargetRow.Fields.ModelCode] = this.model.value;

            return true;
        }

        private searchText: string;

        protected createQuickSearchInput() {
            
			Serenity.GridUtils.addQuickSearchInputCustom(this.toolbar.element, (field, text, done) => {
				this.searchText = Select2.util.stripDiacritics(text || '').toLowerCase();
                this.view.setItems(this.view.getItems(), true);
                done && done(true);
            });
        }

        protected onViewFilter(item: ModelTargetRow): boolean {
            if (!super.onViewFilter(item)) {
                return false;
            }

            if (!Serenity.SlickTreeHelper.filterById(item, this.view, x => this.getParentId(x)))
                return false;

            if (this.focusToKey != null &&
                this.focusToKeys != null &&
                !this.focusToKeys[item.TargetCode])
                return false;
        
            if (!this.searchText)
				return true;

            return this.containsSearchText(item) || Q.any(this.getDescendants(item), x => this.containsSearchText(x));
        }

        private getCode(item: ModelTargetRow) {
			if (item.TargetCode == "-1")
				return item.Code1;

			return (item["Code" + item.Level] || '');
        }

		private getName(item: ModelTargetRow) {
			if (item.TargetCode == "-1")
				return item.Name1;

			return (item["Name" + item.Level] || '');
		}

		private containsSearchText(item: ModelTargetRow): boolean {
            return Select2.util.stripDiacritics(this.getCode(item)).toLowerCase().indexOf(this.searchText) >= 0 ||
                Select2.util.stripDiacritics(this.getName(item)).toLowerCase().indexOf(this.searchText) >= 0;
        }

        onViewProcessData(response: Serenity.ListResponse<ModelTargetRow>) {
            this._byParentId = null;
            this.focusToKey = null;
            this.focusToKeys = null;

            response = super.onViewProcessData(response);
            if (this.model.value) {
                var model = ModelRow.getLookup().itemById[this.model.value];
                if (model) {
                    response.Entities.splice(0, 0, {
                        TargetCode: "-1",
                        Level: 0,
                        Code1: model.ModelCode,
                        Name1: model.Name
                    });
                }
            }
            return response;
        }

        usePager() {
            return false;
        }

        protected getColumns() {
            var columns = super.getColumns();
            
            Q.first(columns, x => x.field == "FocusTo").format = ctx => {
                var targetCode = (ctx.item as ModelTargetRow).TargetCode;
                if (targetCode == "-1")
                    return "";

                return '<a class="inline-action focus-to" title="Focus on this row"><i class="fa fa-crosshairs ' + 
                    (this.focusToKey === targetCode ? 'text-red' : 'text-gray') + '"></i></a>';
            };

            Q.first(columns, x => x.field == "ExpandCollapseDescendants").format = ctx => {
                var item = ctx.item as ModelTargetRow;
                var children = this.byParentId[item.TargetCode];
                if (!children || !children.length)
                    return "";

                if (!item['_collapsed'] && !Q.any(children, c => {
                    var cc = this.byParentId[c.TargetCode];
                    return cc && cc.length > 0;
                })) {
                    return "";
                }

                var anyCollapse = item['_collapsed'] || Q.any(children, c => {
                    var cc = this.byParentId[c.TargetCode];
                    return cc && cc.length > 0 && !!c['_collapsed'];
                });
                
                return '<a class="inline-action expand-collapse-descendants" title="' + 
                    (anyCollapse ? "expand-descendants" : "collapse-descendants") +
                    '"><i class="mdi ' + (anyCollapse ? "mdi-expand-all-outline" : "mdi-collapse-all-outline") + ' text-black"></i></a>';
            };

            Q.first(columns, x => x.field == "AddChild").format = ctx => {
                if ((ctx.item as ModelTargetRow).Level >= 10)
                    return "";

                var model = ModelRow.getLookup().itemById[this.model.value];
                if (model && model.Levels <= (ctx.item as ModelTargetRow).Level)
                    return "";

                return '<a class="inline-action add-child-item add-child-model-target" title="Add child target"></a>';
            };

            var targetCodeFormat = this.itemLink(null, null, ctx => {
                var item = ctx.item as ModelTargetRow;
                return (item["Code" + item.Level] || '');
            });

            Q.first(columns, x => x.field == "TargetCode").format = ctx => ctx.item.TargetCode == "-1" ? Q.htmlEncode(ctx.item.Code1) : targetCodeFormat(ctx);

            var targetNameFormat = this.itemLink(null, null, ctx => {
                var item = ctx.item as ModelTargetRow;
                return (item["Name" + item.Level] || '');
            });

            Q.first(columns, x => x.field == "TargetName").format = ctx => ctx.item.TargetCode == "-1" ? Q.htmlEncode(ctx.item.Name1) : targetNameFormat(ctx);

            Q.first(columns, x => x.field == "Level").format = ctx => {
                var item = ctx.item as ModelTargetRow;
                var level = item.Level;
                if (!level || level < 1 || level > 10)
                    return "";

                var model = ModelRow.getLookup().itemById[this.model.value];
                if (!model)
                    return "";

                return level.toString();
            };

            Q.first(columns, x => x.field == "LevelName").format = ctx => {
                var item = ctx.item as ModelTargetRow;
                var level = item.Level;
                if (!level || level < 1 || level > 10)
                    return "";

                var model = ModelRow.getLookup().itemById[this.model.value];
                if (!model)
                    return "";

                return(model['LevelName' + level] || '');
            };

            var displayOrder = Q.first(columns, x => x.field == 'SiblingDisplayOrder');
            displayOrder.behavior = "selectAndMove";
            displayOrder.format = ctx => {
                var item = ctx.item as ModelTargetRow;
                if (item.TargetCode == "-1")
                    return "";

                return "<i class='fa fa-bars text-lime pull-right'></i> <span>" + ctx.value + "</span>";
            };

            return columns;
        }

        private moveItem(from: number, to: number) {
            if (from == to)
                return;

            var fromItem = this.itemAt(from);
            if (fromItem == null || fromItem.TargetCode == "-1")
                return;

            var fromParent = this.getParentId(fromItem);

            var toItem = this.itemAt(to);
            if (toItem == null)
                return;

            var toParent = this.getParentId(toItem);

            if (fromParent != toParent) {
                Q.notifyWarning("Can only move item among its siblings!");
                return;
            }

            ModelTargetService.Update({
                EntityId: fromItem.RowId,
                Entity: {
                    SiblingDisplayOrder: toItem.SiblingDisplayOrder || 1
                }
            }, response => this.refresh());
        }

        protected editItem(item: any) {
            if (typeof item == "string" || typeof item == "number") {
                var x = this.view.getItemById(item) as ModelTargetRow;
                if (x)
                    super.editItem(x.RowId);
            }
            else
                super.editItem(item);
        }

        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row) as ModelTargetRow;
            var target = $(e.target);

            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('add-child-model-target')) {
                    if (item.TargetCode == "-1") {
                        this.editItem(<ModelTargetRow>{
                            ModelCode: this.model.value,
                            Level: 1,
                            TargetCode: '/'
                        });
                        return;
                    }

                    var x: ModelTargetRow = {
                        TargetCode: item.TargetCode + '/',
                        Level: item.Level + 1,
                        ModelCode: item.ModelCode,
                    };
                    for (var l = 1; l <= item.Level; l++) {
                        x['Code' + l] = item['Code' + l];
                        x['Name' + l] = item['Name' + l];
                    }
                    this.editItem(x);
                }
                else if (target.hasClass('focus-to')) {
                    if (this.focusToKey === item.TargetCode) {
                        this.focusToKey = null;
                        this.focusToKeys = null;
                    }
                    else {
                        this.focusToKey = item.TargetCode;
                        this.focusToKeys = {};
                        this.focusToKeys["-1"] = true;
                        this.focusToKeys[item.TargetCode] = true;
                        for (var x of this.getParents(item))
                            this.focusToKeys[x.TargetCode] = true;
                        for (var x of this.getDescendants(item))
                            this.focusToKeys[x.TargetCode] = true;
                    }

                    this.view.refresh();
                    this.slickGrid.invalidate();
                }
                else if (target.hasClass("expand-collapse-descendants")) {
                    var descendants = this.getDescendants(item);
                    var anyChildrenExpanded = target.children('i').hasClass('mdi-collapse-all-outline');

                    this.view.beginUpdate();
                    try {
                        Serenity.SlickTreeHelper.setCollapsed([item], false);
                        Serenity.SlickTreeHelper.setCollapsed(descendants, anyChildrenExpanded);
                    }
                    finally {
                        this.view.endUpdate();
                    }
                    this.slickGrid.invalidate();
                }
            }
        }
    }
}